import SingletonService from "./Singleton.service";
const pluralRules = SingletonService.makeSingleton(() => Intl.PluralRules && new Intl.PluralRules("en-US", { type: "ordinal" }));
const pluralSuffixes = SingletonService.makeSingleton(() => new Map([
    ["one", "st"],
    ["two", "nd"],
    ["few", "rd"],
    ["other", "th"],
]));
export default class NumberService {
    static asPercentage(decimal, numDecimals = 2) {
        // When something is divided by 0, in almost all cases, we want to display this number as 0 instead of Infinity.
        if (decimal === Infinity) {
            return NumberService.asPercentage(0, numDecimals);
        }
        return ((decimal || 0) * 100).toFixed(numDecimals);
    }
    static roundToDigits(number, numDecimals) {
        return Math.round(number * Math.pow(10, numDecimals)) / Math.pow(10, numDecimals);
    }
    static format(number) {
        return new Intl.NumberFormat().format(number);
    }
    static isValid(number) {
        // eslint-disable-next-line no-restricted-globals
        return isFinite(number);
    }
    static withLeadingZero(number) {
        return Math.abs(number) < 10 ? "0" + number : number.toString();
    }
    static toOrdinalString(number) {
        return NumberService.asOrdinal(number);
    }
    static asOrdinal(number) {
        var _a, _b;
        if (number == null) {
            return "";
        }
        if (!pluralRules()) {
            return "";
        }
        return `${number}${(_b = pluralSuffixes().get((_a = pluralRules()) === null || _a === void 0 ? void 0 : _a.select(number))) !== null && _b !== void 0 ? _b : ""}`;
    }
}
